<script setup lang="ts">
import { useThemeStore } from './themes-store'
import ThemeRadio from './ThemeRadio.component.vue'

const emits = defineEmits<{
  (e: 'themeSelected', themeId: string): any
}>()

const { themes, availableThemes, selectedTheme, setNewTheme } = useThemeStore()
const refIndex = ref(themes.value.indexOf(selectedTheme.value))
const refWorking = ref(false)
//let direction = 1

// show one button and cycle through themes instead of displaying multiple buttons
// (this go up and down in the list flipping direction at each bound)
const onRadioClicked = (value: string) => {
  refWorking.value = true
  // const maxIndex = themes.value.length - 1
  // let index = refIndex.value
  // if (index >= maxIndex) {
  //   direction = -1
  // } else if (index < 1) {
  //   direction = 1
  // }
  // index += direction

  const indexOfValue = availableThemes.map((x) => x.id).indexOf(value)
  const maxIndex = availableThemes.length
  let index = 1 + indexOfValue
  if (index >= maxIndex) {
    index = 0
  }

  const themeInfo = themes.value[index]
  console.group('themeInfo', value, indexOfValue, themeInfo)
  if (themeInfo) {
    const nextId = themeInfo.id
    themeInfo.selected = true
    refIndex.value = index
    setTimeout(() => {
      setNewTheme(nextId)
      emits('themeSelected', nextId)
    }, 0)
    setTimeout(() => (refWorking.value = false), 500)
  } else {
    refWorking.value = false
  }
}
</script>

<template>
  <ClientOnly>
    <div v-show="!refWorking" class="theme-selector z-50">
      <div class="theme-radio-group">
        <ThemeRadio
          v-if="selectedTheme"
          :key="0"
          :index="refIndex"
          :themeInfo="selectedTheme"
          @clicked="onRadioClicked"
        />
      </div>
    </div>
  </ClientOnly>
</template>
